import { useMemo } from "react";
import { isWithinInterval } from "date-fns";

/**
 * Return a memoized date for now.
 */
export function useNow() {
  return useMemo(() => new Date(), []);
}

/**
 * Return true if now is between the given dates.
 *
 * We use strings for datetimes here to discourage calculating a new Date on
 * every render. Strings are better for memoization.
 */
export function useBetweenTime(start: string, end: string) {
  const now = useNow();

  return useMemo(
    () => isWithinInterval(now, { start, end }),
    [now, start, end],
  );
}
